"use client";
import { useState } from "react";
import dynamic from "next/dynamic";

import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { Ga4WithEventParameters } from "@/src/helpers/google-tag-manager/events/ga4-with-eventparameters";
import { runIdle } from "@/src/utils/idle-utils";

import { handleMessageModalOpened } from "@/src/store/listingDetail";

import Button from "components/common/button";
import LoginStepModalContent from "components/common/login-step-modal-content";
import ModalTextContent from "components/modal-text-content";

const Modal = dynamic(() => import("components/common/modal"), { ssr: false });

const SendMessageButton = ({ size = "M", listingId }) => {
  const [isMessageButtonHandled, setIsMessageButtonHandled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useDispatch();

  const handleModalClose = () => setIsModalOpen(false);

  const handleLoginSuccessCallback = () => {
    setIsModalOpen(false);
    dispatch(handleMessageModalOpened());
  };

  const handleMessageAction = async () => {
    setTimeout(() => {
      const isLogin = localStorage.getItem("user-data");
      if (isLogin) {
        dispatch(handleMessageModalOpened());
      } else {
        setIsModalOpen(true);
      }
      setIsMessageButtonHandled(false);
    }, 0);

    runIdle(() => {
      Ga4WithEventParameters({
        eventName: "click_message",
        eventParameters: { item_id: listingId.toString() },
      });
    }, 1000);
  };

  return (
    <>
      <Button size={size} outline onClick={() => handleMessageAction()} isLoading={isMessageButtonHandled}>
        Mesaj Gönder
      </Button>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} handleClose={() => handleModalClose()}>
          <ModalTextContent>
            <LoginStepModalContent handleLoginSuccessCallback={handleLoginSuccessCallback} />
          </ModalTextContent>
        </Modal>
      )}
    </>
  );
};

SendMessageButton.propTypes = {
  size: PropTypes.string,
  listingId: PropTypes.number,
};

export default SendMessageButton;
